import { cutBreadcrumbActiveItem } from './cut-breadcrumb'

const resizeObserver = new ResizeObserver((entries) => {
  cutBreadcrumbActiveItem();
});



document.addEventListener("DOMContentLoaded", function(event) {
    resizeObserver.observe(document.querySelector(('body')))
    let copyButton = document.querySelector('#copy-button');
    if(copyButton){

      copyButton.addEventListener('click',()=>{
        if(window.isSecureContext) {
          navigator.clipboard.writeText(window.location.href);
        }

        let copyButtonOriginalText = copyButton.innerHTML;
        copyButton.innerHTML = 'Skopiowano ! '

        setTimeout(()=>{
          copyButton.innerHTML = copyButtonOriginalText;
         },1500)


      })

    }
  });
